import { View } from 'react-native'

import { styled } from '~/utils'

export const Body = styled(View, theme => {
  return {
    base: {
      backgroundColor: theme.colorContainerFillDefault,
      borderColor: theme.colorContainerBorderDefault,
      borderLeftWidth: theme.borderWidthQuarterpulse,
      borderRightWidth: theme.borderWidthQuarterpulse,
      borderTopWidth: theme.borderWidthNone,
      borderBottomWidth: theme.borderWidthNone,
      paddingLeft: theme.paddingInsetFourpulse,
      paddingRight: theme.paddingInsetFourpulse,
      paddingTop: theme.paddingInsetFourpulse,
      paddingBottom: theme.paddingInsetFourpulse,
    },
    variants: {},
  }
})
